import { useState, useEffect } from "react";
import { images } from "../../constants/images";
import "../../assets/stylesheets/bootstrap.min.css";
import "../../assets/stylesheets/style.css";
import "../../assets/stylesheets/responsive.css";

export default function CustomBusinessSoftware() {
  useEffect(() => {
    document.title = "Custom Business Software Development | Plural Code";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="custom-software-page">
      {/* HERO SECTION */}
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center min-vh-90">
            <div className="col-lg-6 col-md-12 mb-5 mb-lg-0">
              <div
                className="text-white position-relative"
                style={{ zIndex: 2 }}
              >
                {/* Badge */}
                <div
                  className="d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill mb-4"
                  style={{
                    background: "rgba(255, 255, 255, 0.15)",
                    backdropFilter: "blur(10px)",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                  }}
                >
                  <span style={{ fontSize: "20px" }}>🚀</span>
                  <span
                    className="fw-bold"
                    style={{ fontSize: "14px", color: "#FFD700" }}
                  >
                    CUSTOM BUSINESS SOFTWARE
                  </span>
                </div>

                {/* Main Heading */}
                <h1
                  className="display-3 fw-bold mb-4"
                  style={{
                    lineHeight: "1.1",
                    background:
                      "linear-gradient(to right, #FFFFFF 0%, #E6F0FF 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    textShadow: "0 2px 10px rgba(0,0,0,0.1)",
                  }}
                >
                  Software Built Around{" "}
                  <span
                    className="d-inline-block"
                    style={{
                      background:
                        "linear-gradient(90deg, #FFD700 0%, #FFEC8B 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                      position: "relative",
                      padding: "0 5px",
                    }}
                  >
                    YOUR
                  </span>{" "}
                  Workflow
                </h1>

                {/* Subtitle */}
                <p
                  className="fs-5 mb-5"
                  style={{
                    color: "#E6F0FF",
                    lineHeight: "1.6",
                    maxWidth: "90%",
                    fontWeight: "300",
                  }}
                >
                  Stop forcing your business into off-the-shelf software. We
                  build solutions that fit your unique processes
                  perfectly—boosting efficiency by up to 68%.
                </p>

                {/* CTA Buttons */}
                <div className="d-flex flex-wrap gap-3 mb-5">
                  <button
                    onClick={() =>
                      window.open(
                        "/lm/custom-software-roi-calculator",
                        "_blank",
                      )
                    }
                    className="btn btn-lg px-5 py-3 d-flex align-items-center gap-2"
                    style={{
                      background:
                        "linear-gradient(135deg, #FFD700 0%, #FFC107 100%)",
                      border: "none",
                      color: "#0a2458",
                      fontWeight: "700",
                      borderRadius: "12px",
                      transition: "all 0.3s ease",
                      boxShadow: "0 10px 30px rgba(255, 215, 0, 0.3)",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-3px)";
                      e.target.style.boxShadow =
                        "0 15px 40px rgba(255, 215, 0, 0.4)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow =
                        "0 10px 30px rgba(255, 215, 0, 0.3)";
                    }}
                  >
                    <span>📊</span>
                    <span>Calculate Your Custom Software ROI</span>
                  </button>

                  <button
                    onClick={() =>
                      window.open(
                        "https://topmate.io/pluralcode/1677658",
                        "_blank",
                      )
                    }
                    className="btn btn-lg px-5 py-3 d-flex align-items-center gap-2"
                    style={{
                      background: "transparent",
                      border: "2px solid #FFD700",
                      color: "#FFD700",
                      fontWeight: "600",
                      borderRadius: "12px",
                      transition: "all 0.3s ease",
                      backdropFilter: "blur(10px)",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = "rgba(255, 215, 0, 0.1)";
                      e.target.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = "transparent";
                      e.target.style.transform = "translateY(0)";
                    }}
                  >
                    <span>📅</span>
                    <span>Schedule Consultation</span>
                  </button>
                </div>

                {/* Trust Indicators */}
                <div className="d-flex align-items-center gap-4">
                  <div className="d-flex">
                    {[1, 2, 3, 4].map((i) => (
                      <div
                        key={i}
                        style={{
                          width: "45px",
                          height: "45px",
                          borderRadius: "50%",
                          background:
                            i === 4 ? "#FFD700" : "rgba(255, 255, 255, 0.2)",
                          border: "2px solid #0a2458",
                          marginLeft: i > 1 ? "-15px" : "0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: i === 4 ? "#0a2458" : "#fff",
                          fontWeight: "700",
                          fontSize: i === 4 ? "16px" : "14px",
                        }}
                      >
                        {i === 4 ? "+200" : `B${i}`}
                      </div>
                    ))}
                  </div>

                  <div className="d-flex flex-column">
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <span style={{ color: "#FFD700", fontSize: "20px" }}>
                        ⭐
                      </span>
                      <span style={{ color: "#FFFFFF", fontWeight: "600" }}>
                        4.9/5 Rating
                      </span>
                    </div>
                    <p
                      className="mb-0"
                      style={{ color: "#E6F0FF", fontSize: "14px" }}
                    >
                      Trusted by 200+ businesses across 20+ industries
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Hero Image */}
            <div className="col-lg-6 col-md-12">
              <div className="position-relative">
                <div
                  style={{
                    position: "relative",
                    padding: "20px",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "0",
                      right: "0",
                      bottom: "0",
                      left: "0",
                      background:
                        "linear-gradient(135deg, rgba(255,215,0,0.15) 0%, rgba(255,215,0,0) 50%)",
                      borderRadius: "25px",
                      transform: "rotate(5deg)",
                      zIndex: 0,
                    }}
                  />

                  <div
                    style={{
                      position: "relative",
                      borderRadius: "20px",
                      overflow: "hidden",
                      boxShadow: "0 25px 50px rgba(0,0,0,0.4)",
                      transform:
                        "perspective(1000px) rotateY(-5deg) rotateX(2deg)",
                      transition: "transform 0.5s ease",
                      zIndex: 1,
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform =
                        "perspective(1000px) rotateY(0deg) rotateX(0deg)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform =
                        "perspective(1000px) rotateY(-5deg) rotateX(2deg)";
                    }}
                  >
                    <img
                      src={images?.customBusinessSoftware}
                      className="img-fluid w-100"
                      alt="Custom Software Dashboard"
                      style={{
                        display: "block",
                        height: "400px",
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />

                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background:
                          "linear-gradient(to bottom, transparent 0%, rgba(10, 36, 88, 0.3) 100%)",
                        pointerEvents: "none",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* THE PROBLEM SECTION */}
      <section className="problem-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-5 mb-lg-0">
              <div className="position-relative">
                <img
                  src={images?.genericSoftwareProblem || images?.aboutUs}
                  className="img-fluid rounded-4"
                  alt="Generic software problems"
                  style={{
                    boxShadow: "0 20px 40px rgba(10, 36, 88, 0.1)",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "-20px",
                    left: "-20px",
                    width: "80px",
                    height: "80px",
                    background: "#dc3545",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "32px",
                    boxShadow: "0 10px 20px rgba(220, 53, 69, 0.3)",
                  }}
                >
                  ⚠️
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-4">
                <span
                  className="px-3 py-1 rounded-pill d-inline-block mb-3"
                  style={{
                    background: "rgba(220, 53, 69, 0.1)",
                    color: "#dc3545",
                    fontWeight: "600",
                    fontSize: "14px",
                  }}
                >
                  COMMON PAIN POINTS
                </span>
                <h2 className="section-title mb-4">
                  Why Generic Software Fails Your Business
                </h2>
                <p className="section-subtitle">
                  You've tried off-the-shelf solutions. Maybe you're using them
                  right now. And you know the problems:
                </p>
              </div>

              {[
                {
                  icon: "🔄",
                  title: "Workflow Mismatch",
                  description:
                    "The software was built for a 'typical' business—but your business isn't typical. You're forced to change how you work instead of the software adapting to you.",
                },
                {
                  icon: "📦",
                  title: "Feature Bloat",
                  description:
                    "You're paying for hundreds of features you'll never use while missing the specific capabilities you actually need.",
                },
                {
                  icon: "🔗",
                  title: "Integration Nightmares",
                  description:
                    "Connecting multiple platforms creates data silos, manual workarounds, and endless frustration.",
                },
                {
                  icon: "📈",
                  title: "Can't Scale",
                  description:
                    "As your business grows and evolves, the software can't keep up. You outgrow it—fast.",
                },
                {
                  icon: "🔒",
                  title: "Vendor Lock-In",
                  description:
                    "You're stuck with their roadmap, their priorities, their limitations. Want a specific feature? Get in line with thousands of other customers.",
                },
              ].map((problem, index) => (
                <div
                  key={index}
                  className="d-flex gap-3 mb-4 p-3 rounded-3"
                  style={{
                    background:
                      index % 2 === 0
                        ? "rgba(220, 53, 69, 0.05)"
                        : "transparent",
                    borderLeft: `3px solid #dc3545`,
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateX(5px)";
                    e.currentTarget.style.background = "rgba(220, 53, 69, 0.1)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateX(0)";
                    e.currentTarget.style.background =
                      index % 2 === 0
                        ? "rgba(220, 53, 69, 0.05)"
                        : "transparent";
                  }}
                >
                  <div
                    className="flex-shrink-0"
                    style={{
                      fontSize: "24px",
                      width: "48px",
                      height: "48px",
                      background: "rgba(220, 53, 69, 0.1)",
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {problem.icon}
                  </div>
                  <div>
                    <h3 className="problem-title">{problem.title}</h3>
                    <p className="problem-description">{problem.description}</p>
                  </div>
                </div>
              ))}

              <div
                className="p-4 mt-5 rounded-4"
                style={{
                  background:
                    "linear-gradient(135deg, rgba(10, 36, 88, 0.05) 0%, rgba(255, 215, 0, 0.05) 100%)",
                  border: "1px solid rgba(10, 36, 88, 0.1)",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-10px",
                    left: "20px",
                    background: "#0a2458",
                    color: "white",
                    padding: "5px 15px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  CLIENT TESTIMONIAL
                </div>
                <p
                  className="fs-16 mb-3"
                  style={{ fontStyle: "italic", color: "#0A2458" }}
                >
                  "We spent 8 months trying to make [popular ERP] work for our
                  manufacturing process. It never fit. Custom development was
                  the breakthrough we needed."
                </p>
                <div className="d-flex align-items-center">
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      background: "#0a2458",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      marginRight: "12px",
                    }}
                  >
                    OM
                  </div>
                  <div>
                    <strong className="fs-16" style={{ color: "#0a2458" }}>
                      Operations Director
                    </strong>
                    <p className="fs-14 mb-0" style={{ color: "#0A2458" }}>
                      Australian Manufacturing Company • 500+ Employees
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* THE SOLUTION SECTION */}
      <section className="solution-section">
        <div className="container">
          <div className="text-center mb-5">
            <span
              className="px-3 py-1 rounded-pill d-inline-block mb-3"
              style={{
                background: "rgba(10, 36, 88, 0.1)",
                color: "#0a2458",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              OUR APPROACH
            </span>
            <h2 className="section-title mb-4">
              Software Built Around YOUR Business
            </h2>
            <p className="section-subtitle mx-auto">
              Custom business software means starting with a blank canvas. No
              pre-built assumptions. No templates. No "close enough."
            </p>
            <p className="section-subtitle mx-auto mt-3">
              We map your exact workflows, understand your challenges, and
              design software that supports how you ACTUALLY operate—not how
              some vendor thinks you should.
            </p>
          </div>

          <div className="row g-4">
            {[
              {
                icon: "🎯",
                title: "Extreme Customization",
                description:
                  "Every feature, every workflow, every screen is designed specifically for your business needs",
              },
              {
                icon: "⚡",
                title: "Competitive Advantage",
                description:
                  "Your software becomes a business asset that competitors can't replicate",
              },
              {
                icon: "📈",
                title: "Scales With You",
                description:
                  "As your business evolves, your software evolves—no limitations, no compromises",
              },
              {
                icon: "🔧",
                title: "Perfect Integration",
                description:
                  "Seamlessly connects with your existing tools and systems",
              },
              {
                icon: "💰",
                title: "Long-term Savings",
                description:
                  "Eliminate recurring subscription fees and own your software outright",
              },
              {
                icon: "🛡️",
                title: "Full Control",
                description:
                  "Complete ownership with no vendor lock-in or dependency",
              },
            ].map((solution, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div
                  className="h-100 p-4 rounded-4"
                  style={{
                    background: "white",
                    border: "1px solid rgba(10, 36, 88, 0.1)",
                    boxShadow: "0 4px 6px rgba(10, 36, 88, 0.05)",
                    transition: "all 0.3s ease",
                    position: "relative",
                    overflow: "hidden",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow =
                      "0 12px 24px rgba(10, 36, 88, 0.1)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 6px rgba(10, 36, 88, 0.05)";
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      right: "0",
                      height: "4px",
                      background:
                        "linear-gradient(90deg, #0a2458 0%, #1a3b8a 50%, #FFD700 100%)",
                    }}
                  />
                  <div
                    className="mb-4 rounded-3 d-inline-flex align-items-center justify-content-center"
                    style={{
                      fontSize: "40px",
                      width: "70px",
                      height: "70px",
                      background: "rgba(10, 36, 88, 0.05)",
                    }}
                  >
                    {solution.icon}
                  </div>
                  <h3 className="solution-card-title">{solution.title}</h3>
                  <p className="solution-card-description">
                    {solution.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHAT WE BUILD SECTION */}
      <section className="services-section">
        <div className="container">
          <div className="text-center mb-5">
            <span
              className="px-3 py-1 rounded-pill d-inline-block mb-3"
              style={{
                background: "rgba(255, 215, 0, 0.15)",
                color: "#0a2458",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              OUR SOLUTIONS
            </span>
            <h2 className="section-title mb-4">
              Types of Custom Business Software We Create
            </h2>
            <p className="section-subtitle mx-auto">
              Tailored solutions designed specifically for your industry and
              business processes
            </p>
          </div>

          <div className="row g-4">
            {[
              {
                icon: "👥",
                title: "Custom CRM Systems",
                description:
                  "Build relationships your way—track leads, manage customers, and automate follow-ups based on YOUR sales process.",
                features: [
                  "Custom lead scoring & routing",
                  "Tailored pipeline stages",
                  "Integration with your existing tools",
                  "Custom reporting dashboards",
                ],
              },
              {
                icon: "🏢",
                title: "Custom ERP Solutions",
                description:
                  "Manage your entire operation with software built for your specific industry and processes—inventory, production, accounting, all connected.",
                features: [
                  "Industry-specific workflows",
                  "Real-time inventory tracking",
                  "Custom approval processes",
                  "Multi-location management",
                ],
              },
              {
                icon: "⚙️",
                title: "Process Management Systems",
                description:
                  "Digitize and optimize your unique business processes—from manufacturing workflows to service delivery operations.",
                features: [
                  "Custom workflow builders",
                  "Task automation & routing",
                  "Real-time status tracking",
                  "Performance analytics",
                ],
              },
              {
                icon: "📦",
                title: "Inventory & Supply Chain",
                description:
                  "Track materials, products, and logistics exactly how your business operates—with rules and automation specific to your industry.",
                features: [
                  "Multi-warehouse management",
                  "Custom reorder logic",
                  "Supplier & vendor management",
                  "Demand forecasting",
                ],
              },
              {
                icon: "📊",
                title: "Business Intelligence Dashboards",
                description:
                  "Turn your data into actionable insights with custom dashboards showing exactly what YOUR business needs to track.",
                features: [
                  "Real-time KPI visualization",
                  "Custom metrics & calculations",
                  "Automated reporting",
                  "Role-based views",
                ],
              },
              {
                icon: "🤖",
                title: "Workflow Automation Platforms",
                description:
                  "Eliminate repetitive manual work by automating your specific business processes—approvals, notifications, data routing.",
                features: [
                  "Custom automation rules",
                  "Multi-step workflows",
                  "Conditional logic",
                  "Integration triggers",
                ],
              },
            ].map((service, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div
                  className="h-100 p-4 rounded-4"
                  style={{
                    background: "white",
                    border: "1px solid rgba(10, 36, 88, 0.1)",
                    boxShadow: "0 5px 15px rgba(10, 36, 88, 0.05)",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow =
                      "0 15px 30px rgba(10, 36, 88, 0.1)";
                    e.currentTarget.style.borderColor = "#0a2458";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 5px 15px rgba(10, 36, 88, 0.05)";
                    e.currentTarget.style.borderColor = "rgba(10, 36, 88, 0.1)";
                  }}
                >
                  <div
                    className="mb-4 rounded-3 d-inline-flex align-items-center justify-content-center"
                    style={{
                      fontSize: "32px",
                      width: "60px",
                      height: "60px",
                      background: "rgba(10, 36, 88, 0.05)",
                    }}
                  >
                    {service.icon}
                  </div>
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-description mb-3">
                    {service.description}
                  </p>
                  <div className="mb-3">
                    <strong
                      className="d-block mb-2"
                      style={{ color: "#0a2458", fontSize: "14px" }}
                    >
                      Common features:
                    </strong>
                    <ul style={{ paddingLeft: "20px", marginBottom: 0 }}>
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="service-feature">
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <button
                    onClick={() =>
                      window.open(
                        "https://topmate.io/pluralcode/1677658",
                        "_blank",
                      )
                    }
                    className="btn w-100 mt-3"
                    style={{
                      background: "transparent",
                      border: "1px solid #0a2458",
                      color: "#0a2458",
                      fontWeight: "600",
                      padding: "10px",
                      borderRadius: "8px",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = "#0a2458";
                      e.target.style.color = "white";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = "transparent";
                      e.target.style.color = "#0a2458";
                    }}
                  >
                    Learn More →
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* OUR PROCESS SECTION */}
      <section className="process-section">
        <div className="container">
          <div className="text-center mb-5">
            <span
              className="px-3 py-1 rounded-pill d-inline-block mb-3"
              style={{
                background: "rgba(10, 36, 88, 0.1)",
                color: "#0a2458",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              OUR PROCESS
            </span>
            <h2 className="section-title mb-4">
              How We Build Your Custom Software
            </h2>
            <p className="section-subtitle mx-auto">
              We don't jump straight into coding. Custom software requires deep
              understanding first.
            </p>
          </div>

          <div className="process-steps">
            {[
              {
                number: 1,
                title: "Discovery & Mapping",
                duration: "2-3 weeks",
                description:
                  "We immerse ourselves in your business to understand your workflows, pain points, and goals.",
                activities: [
                  "Interview key stakeholders",
                  "Map current workflows & processes",
                  "Identify pain points & bottlenecks",
                  "Document requirements & goals",
                ],
                deliverable: "Detailed requirements document & process maps",
              },
              {
                number: 2,
                title: "Design & Architecture",
                duration: "2-3 weeks",
                description:
                  "Before writing a single line of code, we design the perfect solution.",
                activities: [
                  "Create wireframes & mockups",
                  "Design database architecture",
                  "Plan system integrations",
                  "Define user roles & permissions",
                ],
                deliverable: "Complete design specs & interactive prototypes",
              },
              {
                number: 3,
                title: "Agile Development",
                duration: "8-16 weeks",
                description:
                  "We build in 2-week sprints with continuous feedback and transparency.",
                activities: [
                  "Regular progress demos",
                  "Weekly status updates",
                  "Continuous feedback incorporation",
                  "Testing alongside development",
                ],
                deliverable: "Working software, sprint by sprint",
              },
              {
                number: 4,
                title: "Testing & Refinement",
                duration: "2-3 weeks",
                description: "Before launch, we ensure quality and perfection.",
                activities: [
                  "Comprehensive testing (functional, performance, security)",
                  "User acceptance testing",
                  "Bug fixes & optimizations",
                  "Documentation & training materials",
                ],
                deliverable: "Production-ready software",
              },
              {
                number: 5,
                title: "Deployment & Training",
                duration: "1-2 weeks",
                description:
                  "Smooth launch and user adoption for maximum impact.",
                activities: [
                  "Deployment to production environment",
                  "Data migration (if applicable)",
                  "User training sessions",
                  "Ongoing support setup",
                ],
                deliverable: "Live system with trained users",
              },
            ].map((step, index) => (
              <div className="process-step" key={index}>
                <div className="step-number">{step.number}</div>
                <div className="step-content">
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <h3 className="step-title mb-0">{step.title}</h3>
                    <span className="step-duration">{step.duration}</span>
                  </div>
                  <p className="step-description mb-3">{step.description}</p>
                  <div className="mb-3">
                    <strong
                      className="d-block mb-2"
                      style={{ color: "#0a2458", fontSize: "14px" }}
                    >
                      Key Activities:
                    </strong>
                    <ul style={{ paddingLeft: "20px", marginBottom: 0 }}>
                      {step.activities.map((activity, idx) => (
                        <li key={idx} className="step-activity">
                          {activity}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="step-deliverable">
                    <strong>Deliverable:</strong> {step.deliverable}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-5">
            <div
              className="p-5 rounded-4"
              style={{
                background:
                  "linear-gradient(135deg, rgba(10, 36, 88, 0.03) 0%, rgba(10, 36, 88, 0.01) 100%)",
                border: "1px solid rgba(10, 36, 88, 0.1)",
              }}
            >
              <div className="d-flex align-items-center justify-content-center gap-3 mb-3">
                <div style={{ fontSize: "32px" }}>🔄</div>
                <h3
                  className="mb-0"
                  style={{ color: "#0a2458", fontSize: "20px" }}
                >
                  <strong>Post-Launch Support</strong>
                </h3>
              </div>
              <p
                className="mb-4 mx-auto"
                style={{
                  maxWidth: "600px",
                  color: "#0A2458",
                  lineHeight: "1.6",
                }}
              >
                We don't disappear after deployment. Ongoing support,
                maintenance, and enhancement options ensure your software
                continues to serve your evolving needs.
              </p>
              <button
                onClick={() => window.open("/services/support", "_blank")}
                className="btn btn-lg px-5 py-3"
                style={{
                  background: "transparent",
                  border: "2px solid #0a2458",
                  color: "#0a2458",
                  fontWeight: "600",
                  borderRadius: "50px",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "#0a2458";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "transparent";
                  e.target.style.color = "#0a2458";
                }}
              >
                Explore Support Plans →
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* CASE STUDY SECTION */}
      <section className="case-study-section">
        <div className="container">
          <div className="text-center mb-5">
            <span
              className="px-3 py-1 rounded-pill d-inline-block mb-3"
              style={{
                background: "rgba(255, 215, 0, 0.15)",
                color: "#0a2458",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              SUCCESS STORY
            </span>
            <h2 className="section-title mb-4">
              Custom Manufacturing Process Management
            </h2>
            <p className="section-subtitle mx-auto">
              How we transformed operations for a mid-sized manufacturing
              company
            </p>
          </div>

          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <div className="position-relative">
                <img
                  src={images?.manufacturingCaseStudy || images?.aboutUs}
                  className="img-fluid rounded-4"
                  alt="Manufacturing Case Study"
                  style={{
                    boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                  }}
                />
                <div
                  className="position-absolute bottom-0 start-0 m-4 p-3 rounded-3"
                  style={{
                    background: "rgba(10, 36, 88, 0.95)",
                    backdropFilter: "blur(10px)",
                    color: "white",
                  }}
                >
                  <div className="d-flex gap-4">
                    <div className="text-center">
                      <div className="fs-24 fw-bold">40%</div>
                      <div className="fs-12">Efficiency Gain</div>
                    </div>
                    <div className="text-center">
                      <div className="fs-24 fw-bold">8</div>
                      <div className="fs-12">Months ROI</div>
                    </div>
                    <div className="text-center">
                      <div className="fs-24 fw-bold">90%</div>
                      <div className="fs-12">Less Quality Issues</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="case-study-content">
                <div className="mb-4">
                  <h3 className="case-study-subtitle">The Client:</h3>
                  <p className="case-study-text">
                    Mid-sized manufacturing company in Australia producing
                    custom industrial components
                  </p>
                </div>

                <div className="mb-4">
                  <h3 className="case-study-subtitle">The Challenge:</h3>
                  <ul className="case-study-list">
                    <li>
                      Juggling spreadsheets, email chains, and disconnected
                      tools
                    </li>
                    <li>No real-time visibility into production status</li>
                    <li>Quality control issues slipping through cracks</li>
                    <li>
                      Off-the-shelf ERP systems were too complex and expensive
                    </li>
                    <li>
                      Needed something tailored to their specific manufacturing
                      process
                    </li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h3 className="case-study-subtitle">Our Solution:</h3>
                  <p className="case-study-text mb-2">
                    We built a custom process management system that:
                  </p>
                  <ul className="case-study-list">
                    <li>
                      <strong>Tracked production</strong> from order to delivery
                      in real-time
                    </li>
                    <li>
                      <strong>Managed inventory</strong> with automatic reorder
                      alerts
                    </li>
                    <li>
                      <strong>Quality control workflows</strong> with photo
                      documentation
                    </li>
                    <li>
                      <strong>Custom reporting</strong> for management & clients
                    </li>
                    <li>
                      <strong>Integrated with</strong> their existing accounting
                      software
                    </li>
                    <li>
                      <strong>Mobile-friendly</strong> for shop floor use
                    </li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h3 className="case-study-subtitle">Technologies Used:</h3>
                  <div className="d-flex flex-wrap gap-2">
                    <span className="tech-tag">Django</span>
                    <span className="tech-tag">PostgreSQL</span>
                    <span className="tech-tag">React</span>
                    <span className="tech-tag">AWS</span>
                    <span className="tech-tag">RESTful APIs</span>
                  </div>
                </div>

                <div
                  className="mb-4 p-4 rounded-4"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(10, 36, 88, 0.05) 0%, rgba(255, 215, 0, 0.05) 100%)",
                    border: "1px solid rgba(10, 36, 88, 0.1)",
                  }}
                >
                  <h3 className="case-study-subtitle mb-3">The Results:</h3>
                  <ul className="case-study-list" style={{ marginBottom: 0 }}>
                    <li>
                      <strong>40% reduction</strong> in process delays
                    </li>
                    <li>
                      <strong>Real-time visibility</strong> across all
                      departments
                    </li>
                    <li>
                      <strong>90% decrease</strong> in quality issues reaching
                      customers
                    </li>
                    <li>
                      <strong>ROI achieved</strong> in 8 months
                    </li>
                    <li>
                      <strong>System scales</strong> as company grows
                    </li>
                  </ul>
                </div>

                <div className="case-study-testimonial">
                  <p
                    className="mb-3"
                    style={{ fontStyle: "italic", color: "#0A2458" }}
                  >
                    "This software transformed how we operate. It was built
                    around our actual process, not forcing us to adapt to
                    generic workflows. Best investment we've made."
                  </p>
                  <div className="d-flex align-items-center">
                    <div
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        background: "#0a2458",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        marginRight: "12px",
                      }}
                    >
                      OM
                    </div>
                    <div>
                      <strong style={{ color: "#0a2458" }}>
                        Operations Manager
                      </strong>
                      <p
                        className="mb-0"
                        style={{ color: "#0A2458", fontSize: "14px" }}
                      >
                        Australian Manufacturing Company
                      </p>
                    </div>
                  </div>
                </div>

                <div className="d-flex gap-3 mt-4 flex-wrap">
                  <button
                    onClick={() =>
                      window.open(
                        "https://topmate.io/pluralcode/1677658",
                        "_blank",
                      )
                    }
                    className="btn btn-lg px-4"
                    style={{
                      background:
                        "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
                      border: "none",
                      color: "white",
                      fontWeight: "600",
                      borderRadius: "12px",
                      padding: "12px 30px",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow =
                        "0 10px 20px rgba(10, 36, 88, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow = "none";
                    }}
                  >
                    Discuss Your Manufacturing Software
                  </button>
                  <button
                    onClick={() => window.open("/case-studies", "_blank")}
                    className="btn btn-lg px-4"
                    style={{
                      background: "transparent",
                      border: "2px solid #0a2458",
                      color: "#0a2458",
                      fontWeight: "600",
                      borderRadius: "12px",
                      padding: "12px 30px",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = "#0a2458";
                      e.target.style.color = "white";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = "transparent";
                      e.target.style.color = "#0a2458";
                    }}
                  >
                    See More Case Studies
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TECHNOLOGIES SECTION */}
      <section className="technologies-section">
        <div className="container">
          <div className="text-center mb-5">
            <span
              className="px-3 py-1 rounded-pill d-inline-block mb-3"
              style={{
                background: "rgba(10, 36, 88, 0.1)",
                color: "#0a2458",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              TECHNOLOGY STACK
            </span>
            <h2 className="section-title mb-4">
              Built with Modern, Proven Technologies
            </h2>
            <p className="section-subtitle mx-auto">
              We use battle-tested frameworks and tools that ensure your
              software is scalable, secure, maintainable, and future-proof.
            </p>
          </div>

          <div className="row g-4">
            {[
              {
                title: "Backend Development",
                icon: "⚙️",
                items: [
                  "Ruby on Rails/Django/Node - Express.js",
                  "PostgreSQL - Reliable, powerful database",
                  "RESTful APIs - Flexible integrations",
                ],
              },
              {
                title: "Frontend Development",
                icon: "🎨",
                items: [
                  "React - Modern, responsive interfaces",
                  "Modern JavaScript (ES6+) - Clean code",
                  "Responsive design - Works on all devices",
                ],
              },
              {
                title: "Infrastructure",
                icon: "☁️",
                items: [
                  "AWS / Cloud hosting - Scalable & reliable",
                  "Automated backups - Your data is safe",
                  "CI/CD pipelines - Smooth deployments",
                  "Monitoring & alerts - Proactive issue detection",
                ],
              },
              {
                title: "Security",
                icon: "🔒",
                items: [
                  "Encrypted data transmission (SSL/TLS)",
                  "Secure authentication & authorization",
                  "Regular security audits",
                  "GDPR/compliance consideration",
                ],
              },
            ].map((tech, index) => (
              <div className="col-lg-3 col-md-6" key={index}>
                <div
                  className="h-100 p-4 rounded-4"
                  style={{
                    background: "rgba(10, 36, 88, 0.02)",
                    border: "1px solid rgba(10, 36, 88, 0.1)",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.background = "rgba(10, 36, 88, 0.05)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.background = "rgba(10, 36, 88, 0.02)";
                  }}
                >
                  <div
                    className="mb-4 rounded-3 d-inline-flex align-items-center justify-content-center"
                    style={{
                      fontSize: "32px",
                      width: "60px",
                      height: "60px",
                      background: "rgba(10, 36, 88, 0.1)",
                    }}
                  >
                    {tech.icon}
                  </div>
                  <h3 className="tech-title">{tech.title}</h3>
                  <ul style={{ paddingLeft: "20px", marginBottom: 0 }}>
                    {tech.items.map((item, idx) => (
                      <li key={idx} className="tech-item">
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-5">
            <div
              className="d-inline-flex align-items-center gap-2 p-3 rounded-3"
              style={{
                background: "rgba(10, 36, 88, 0.05)",
                border: "1px solid rgba(10, 36, 88, 0.1)",
              }}
            >
              <div style={{ fontSize: "20px" }}>💡</div>
              <div className="text-start">
                <p
                  className="mb-0"
                  style={{ color: "#0A2458", fontSize: "14px" }}
                >
                  <strong>Technology is a tool, not the goal.</strong> We choose
                  the right stack for YOUR specific needs, not what's trendy.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* COMPARISON SECTION */}
      <section className="comparison-section">
        <div className="container">
          <div className="text-center mb-5">
            <span
              className="px-3 py-1 rounded-pill d-inline-block mb-3"
              style={{
                background: "rgba(255, 215, 0, 0.15)",
                color: "#0a2458",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              MAKE THE RIGHT CHOICE
            </span>
            <h2 className="section-title mb-4">
              Custom vs Off-the-Shelf Software
            </h2>
            <p className="section-subtitle mx-auto">
              A detailed comparison to help you make the best decision for your
              business
            </p>
          </div>

          <div className="comparison-table">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Factor</th>
                    <th>Custom Software</th>
                    <th>Off-the-Shelf Software</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    {
                      factor: "Workflow Fit",
                      custom: "✅ Perfect match to YOUR process",
                      shelf: "⚠️ You adapt to their process",
                    },
                    {
                      factor: "Features",
                      custom: "✅ Only what you need",
                      shelf: "❌ Feature bloat + missing essentials",
                    },
                    {
                      factor: "Scalability",
                      custom: "✅ Grows exactly as you need",
                      shelf: "⚠️ Limited by platform",
                    },
                    {
                      factor: "Integration",
                      custom: "✅ Built to connect seamlessly",
                      shelf: "⚠️ Limited connectors",
                    },
                    {
                      factor: "Competitive Edge",
                      custom: "✅ Unique advantage",
                      shelf: "❌ Everyone uses same tools",
                    },
                    {
                      factor: "Initial Investment",
                      custom: "Higher upfront",
                      shelf: "Lower upfront",
                    },
                    {
                      factor: "Long-term Cost",
                      custom: "Lower (no per-user fees)",
                      shelf: "Higher (recurring subscriptions)",
                    },
                    {
                      factor: "Control",
                      custom: "✅ Full ownership & control",
                      shelf: "❌ Vendor dictates roadmap",
                    },
                    {
                      factor: "Time to Launch",
                      custom: "3-4 months typically",
                      shelf: "Faster (days/weeks)",
                    },
                  ].map((row, index) => (
                    <tr key={index}>
                      <td>
                        <strong>{row.factor}</strong>
                      </td>
                      <td>{row.custom}</td>
                      <td>{row.shelf}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="row mt-5 g-4">
            <div className="col-lg-6">
              <div className="decision-card positive">
                <div className="decision-header">
                  <div className="decision-icon">✅</div>
                  <h3>Custom Software Makes Sense When:</h3>
                </div>
                <ul className="decision-list">
                  <li>
                    Your workflow is unique and doesn't fit standard software
                  </li>
                  <li>
                    You're using 3+ disconnected tools that should talk to each
                    other
                  </li>
                  <li>
                    You need a competitive advantage through better processes
                  </li>
                  <li>Off-the-shelf subscription costs add up over time</li>
                  <li>You're spending significant time on workarounds</li>
                  <li>
                    Your business is growing and needs software to scale with it
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="decision-card neutral">
                <div className="decision-header">
                  <div className="decision-icon">⚠️</div>
                  <h3>Off-the-Shelf Might Be Better If:</h3>
                </div>
                <ul className="decision-list">
                  <li>Your process is standard (e.g., basic bookkeeping)</li>
                  <li>You need something immediately (can't wait 3+ months)</li>
                  <li>Budget is extremely limited</li>
                  <li>You're testing an idea and need flexibility to pivot</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="text-center mt-5">
            <p
              className="mb-4"
              style={{ fontSize: "18px", color: "#0A2458", fontWeight: "600" }}
            >
              <strong>Not Sure? Use Our Decision Tools:</strong>
            </p>
            <div className="d-flex gap-3 justify-content-center flex-wrap">
              <button
                onClick={() => window.open("/lm/roi-calculator", "_blank")}
                className="btn btn-lg px-4"
                style={{
                  background:
                    "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
                  border: "none",
                  color: "white",
                  fontWeight: "600",
                  borderRadius: "12px",
                  padding: "12px 30px",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow =
                    "0 10px 20px rgba(10, 36, 88, 0.3)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "none";
                }}
              >
                ROI Calculator →
              </button>
              <button
                onClick={() => window.open("/lm/decision-matrix", "_blank")}
                className="btn btn-lg px-4"
                style={{
                  background:
                    "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
                  border: "none",
                  color: "white",
                  fontWeight: "600",
                  borderRadius: "12px",
                  padding: "12px 30px",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow =
                    "0 10px 20px rgba(10, 36, 88, 0.3)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "none";
                }}
              >
                Decision Matrix →
              </button>
              <button
                onClick={() =>
                  window.open("https://topmate.io/pluralcode/1677658", "_blank")
                }
                className="btn btn-lg px-4"
                style={{
                  background: "transparent",
                  border: "2px solid #0a2458",
                  color: "#0a2458",
                  fontWeight: "600",
                  borderRadius: "12px",
                  padding: "12px 30px",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "#0a2458";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "transparent";
                  e.target.style.color = "#0a2458";
                }}
              >
                Schedule Consultation →
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="faq-section">
        <div className="container">
          <div className="text-center mb-5">
            <span
              className="px-3 py-1 rounded-pill d-inline-block mb-3"
              style={{
                background: "rgba(10, 36, 88, 0.1)",
                color: "#0a2458",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              FAQ
            </span>
            <h2 className="section-title mb-4">Frequently Asked Questions</h2>
            <p className="section-subtitle mx-auto">
              Get answers to common questions about custom business software
              development
            </p>
          </div>

          <div className="row">
            <div className="col-lg-8 mx-auto">
              {[
                {
                  q: "How long does custom software development take?",
                  a: "Typically 3-6 months for most business software projects, depending on complexity. We work in agile sprints, so you see progress every 2 weeks.",
                },
                {
                  q: "What if my requirements change during development?",
                  a: "That's normal! Our agile process embraces change. We incorporate feedback and adjusted requirements throughout development.",
                },
                {
                  q: "Do I own the code and intellectual property?",
                  a: "Yes, absolutely. You own all code, documentation, and IP rights. No vendor lock-in.",
                },
                {
                  q: "Can custom software integrate with my existing tools?",
                  a: "Yes. We specialize in building integrations with accounting software, CRMs, e-commerce platforms, and other business tools.",
                },
                {
                  q: "What happens after launch?",
                  a: "We offer ongoing support and maintenance plans. We're here for bug fixes, updates, enhancements, and evolution as your business grows.",
                },
                {
                  q: "Is custom software secure?",
                  a: "Security is built-in from day one. We follow industry best practices for encryption, authentication, and data protection.",
                },
                {
                  q: "What if I need changes or new features later?",
                  a: "Your software evolves with you. We can add features, modify workflows, or expand functionality as your needs change.",
                },
                {
                  q: "How is this different from hiring an in-house developer?",
                  a: "You get an entire team (developers, designers, project managers) without the overhead of full-time employees. Plus, we bring experience from multiple projects.",
                },
                {
                  q: "Can you show me progress during development?",
                  a: "Absolutely. You get weekly demos, access to staging environment, and transparent project tracking throughout.",
                },
                {
                  q: "What industries do you serve?",
                  a: "We've built custom software for manufacturing, professional services, healthcare, logistics, retail, and more. Every industry has unique needs—we adapt.",
                },
              ].map((faq, index) => (
                <div
                  key={index}
                  className="faq-item mb-3"
                  onClick={(e) => {
                    const content =
                      e.currentTarget.querySelector(".faq-answer");
                    if (content.style.maxHeight) {
                      content.style.maxHeight = null;
                      e.currentTarget.classList.remove("active");
                    } else {
                      content.style.maxHeight = content.scrollHeight + "px";
                      e.currentTarget.classList.add("active");
                    }
                  }}
                >
                  <div className="faq-question">
                    <h3>{faq.q}</h3>
                    <span className="faq-toggle">+</span>
                  </div>
                  <div className="faq-answer">
                    <p>{faq.a}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="cta-section">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="cta-title">
              Ready to Build Software That Fits Your Business?
            </h2>
            <p className="cta-subtitle">
              Let's start with a conversation about your challenges, workflows,
              and goals. No pressure, no sales pitch—just an honest discussion
              about whether custom software makes sense for you.
            </p>
          </div>

          <div className="row g-4 justify-content-center">
            {[
              {
                icon: "📊",
                title: "Free Assessment Tools",
                description:
                  "Not ready to talk? Start with data-driven insights:",
                items: [
                  "ROI Calculator - Calculate potential return",
                  "Decision Matrix - Assess if custom is right",
                  "Requirements Worksheet - Document your needs",
                ],
                buttonText: "Explore Free Tools →",
                onClick: () => window.open("/lm/tools", "_blank"),
              },
              {
                icon: "💬",
                title: "Free Consultation",
                description: "30-minute strategy call to discuss:",
                items: [
                  "Your current challenges",
                  "Workflow & process review",
                  "Potential solutions",
                  "Ballpark timeline & investment",
                ],
                buttonText: "Schedule Consultation →",
                onClick: () =>
                  window.open(
                    "https://topmate.io/pluralcode/1677658",
                    "_blank",
                  ),
              },
              {
                icon: "🚀",
                title: "Project Inquiry",
                description: "Ready to start? Let's discuss your project:",
                items: [
                  "Brief description of your needs",
                  "Current challenges you're facing",
                  "Timeline expectations",
                  "Budget considerations",
                ],
                buttonText: "Submit Project Inquiry →",
                onClick: () =>
                  window.open(
                    "https://topmate.io/pluralcode/1677658?type=project",
                    "_blank",
                  ),
              },
            ].map((option, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div className="cta-card">
                  <div className="cta-icon">{option.icon}</div>
                  <h3 className="cta-card-title">{option.title}</h3>
                  <p className="cta-card-description">{option.description}</p>
                  <ul className="cta-card-list">
                    {option.items.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                  <button onClick={option.onClick} className="cta-card-button">
                    {option.buttonText}
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-5">
            <div className="contact-info">
              <div className="d-flex justify-content-center gap-4 flex-wrap">
                <div className="contact-item">
                  <div className="contact-icon">📧</div>
                  <div>
                    <div className="contact-label">Email</div>
                    <div className="contact-value">info@pluralcode.com</div>
                  </div>
                </div>
                <div className="contact-item">
                  <div className="contact-icon">📞</div>
                  <div>
                    <div className="contact-label">Phone</div>
                    <div className="contact-value">+91 99589 20231</div>
                  </div>
                </div>
                <div className="contact-item">
                  <div className="contact-icon">⚡</div>
                  <div>
                    <div className="contact-label">Response Time</div>
                    <div className="contact-value highlight">
                      Within 24 Hours
                    </div>
                  </div>
                </div>
              </div>
              <p className="mt-4" style={{ color: "rgba(255, 255, 255, 0.8)" }}>
                Serving businesses of all sizes and industries around the world.
              </p>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .custom-software-page {
          font-family:
            -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          overflow-x: hidden;
        }

        /* Hero Section */
        .hero-section {
          background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
          min-height: 90vh;
          display: flex;
          align-items: center;
          padding: 80px 0;
          position: relative;
          overflow: hidden;
        }

        .hero-section::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background:
            radial-gradient(
              circle at 20% 80%,
              rgba(255, 215, 0, 0.15) 0%,
              transparent 50%
            ),
            radial-gradient(
              circle at 80% 20%,
              rgba(255, 255, 255, 0.1) 0%,
              transparent 50%
            );
        }

        /* Section Titles */
        .section-title {
          font-size: clamp(2rem, 4vw, 2.75rem);
          color: #0a2458;
          font-weight: 700;
          line-height: 1.2;
          margin-bottom: 1rem;
        }

        .section-subtitle {
          font-size: 1.125rem;
          color: #0a2458;
          line-height: 1.6;
          max-width: 700px;
        }

        /* Problem Section */
        .problem-section {
          padding: 100px 0;
          background: linear-gradient(180deg, #ffffff 0%, #f8faff 100%);
        }

        .problem-title {
          font-size: 1.125rem;
          color: #0a2458;
          font-weight: 600;
          margin-bottom: 0.25rem;
        }

        .problem-description {
          font-size: 0.95rem;
          color: #0a2458;
          margin: 0;
          line-height: 1.5;
        }

        /* Solution Section */
        .solution-section {
          padding: 100px 0;
          background: white;
        }

        .solution-card-title {
          font-size: 1.25rem;
          color: #0a2458;
          font-weight: 600;
          margin-bottom: 0.75rem;
        }

        .solution-card-description {
          font-size: 0.95rem;
          color: #0a2458;
          margin: 0;
          line-height: 1.5;
        }

        /* Services Section */
        .services-section {
          padding: 100px 0;
          background: linear-gradient(180deg, #ffffff 0%, #f0f7ff 100%);
        }

        .service-title {
          font-size: 1.25rem;
          color: #0a2458;
          font-weight: 600;
          margin-bottom: 0.75rem;
        }

        .service-description {
          font-size: 0.95rem;
          color: #0a2458;
          margin: 0;
          line-height: 1.5;
        }

        .service-feature {
          font-size: 0.875rem;
          color: #0a2458;
          margin-bottom: 0.25rem;
          line-height: 1.4;
        }

        /* Process Section */
        .process-section {
          padding: 100px 0;
          background: white;
        }

        .process-steps {
          max-width: 900px;
          margin: 0 auto;
        }

        .process-step {
          background: rgba(10, 36, 88, 0.02);
          border: 1px solid rgba(10, 36, 88, 0.1);
          border-radius: 16px;
          padding: 30px;
          margin-bottom: 30px;
          position: relative;
          transition: all 0.3s ease;
        }

        .process-step:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(10, 36, 88, 0.1);
          background: rgba(10, 36, 88, 0.05);
        }

        .step-number {
          position: absolute;
          top: -15px;
          left: 30px;
          background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
          color: white;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          font-weight: 700;
          box-shadow: 0 5px 15px rgba(10, 36, 88, 0.2);
        }

        .step-content {
          margin-left: 20px;
        }

        .step-title {
          font-size: 1.5rem;
          color: #0a2458;
          font-weight: 600;
        }

        .step-duration {
          background: rgba(10, 36, 88, 0.1);
          color: #0a2458;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 0.875rem;
          font-weight: 600;
        }

        .step-description {
          font-size: 1rem;
          color: #0a2458;
          margin: 0;
          line-height: 1.5;
        }

        .step-activity {
          font-size: 0.9rem;
          color: #0a2458;
          margin-bottom: 0.25rem;
          line-height: 1.4;
        }

        .step-deliverable {
          background: rgba(255, 215, 0, 0.1);
          border: 1px solid rgba(255, 215, 0, 0.2);
          border-radius: 8px;
          padding: 12px;
          font-size: 0.9rem;
          color: #0a2458;
          margin-top: 15px;
        }

        /* Case Study Section */
        .case-study-section {
          padding: 100px 0;
          background: linear-gradient(180deg, #f8faff 0%, #ffffff 100%);
        }

        .case-study-content {
          padding: 20px;
        }

        .case-study-subtitle {
          font-size: 1.25rem;
          color: #0a2458;
          font-weight: 600;
          margin-bottom: 0.75rem;
        }

        .case-study-text {
          font-size: 1rem;
          color: #0a2458;
          line-height: 1.6;
          margin-bottom: 1rem;
        }

        .case-study-list {
          padding-left: 20px;
          margin-bottom: 1rem;
        }

        .case-study-list li {
          font-size: 0.95rem;
          color: #0a2458;
          margin-bottom: 0.5rem;
          line-height: 1.5;
        }

        .case-study-testimonial {
          background: white;
          border: 1px solid rgba(10, 36, 88, 0.1);
          border-radius: 12px;
          padding: 20px;
          margin-top: 20px;
        }

        .tech-tag {
          background: rgba(10, 36, 88, 0.1);
          color: #0a2458;
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 0.875rem;
          font-weight: 500;
        }

        /* Technologies Section */
        .technologies-section {
          padding: 100px 0;
          background: white;
        }

        .tech-title {
          font-size: 1.25rem;
          color: #0a2458;
          font-weight: 600;
          margin-bottom: 0.75rem;
        }

        .tech-item {
          font-size: 0.9rem;
          color: #0a2458;
          margin-bottom: 0.5rem;
          line-height: 1.4;
        }

        /* Comparison Section */
        .comparison-section {
          padding: 100px 0;
          background: linear-gradient(180deg, #ffffff 0%, #f8faff 100%);
        }

        .comparison-table {
          background: white;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(10, 36, 88, 0.1);
        }

        .comparison-table table {
          margin: 0;
          border: none;
        }

        .comparison-table th {
          background: #0a2458;
          color: white;
          font-weight: 600;
          padding: 20px;
          border: none;
          text-align: center;
        }

        .comparison-table td {
          padding: 20px;
          border-bottom: 1px solid #f1f5f9;
          color: #0a2458;
          text-align: center;
          vertical-align: middle;
        }

        .comparison-table tr:last-child td {
          border-bottom: none;
        }

        .comparison-table tr:hover td {
          background: rgba(10, 36, 88, 0.02);
        }

        .decision-card {
          border-radius: 16px;
          padding: 30px;
          height: 100%;
          transition: transform 0.3s ease;
        }

        .decision-card:hover {
          transform: translateY(-5px);
        }

        .decision-card.positive {
          background: linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 100%);
          border: 1px solid #4caf50;
        }

        .decision-card.neutral {
          background: linear-gradient(135deg, #fff3e0 0%, #fff8e1 100%);
          border: 1px solid #ff9800;
        }

        .decision-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
        }

        .decision-icon {
          font-size: 24px;
        }

        .decision-card h3 {
          font-size: 1.25rem;
          color: #0a2458;
          font-weight: 600;
          margin: 0;
        }

        .decision-list {
          padding-left: 20px;
          margin: 0;
        }

        .decision-list li {
          font-size: 0.95rem;
          color: #0a2458;
          margin-bottom: 0.75rem;
          line-height: 1.5;
        }

        /* FAQ Section */
        .faq-section {
          padding: 100px 0;
          background: white;
        }

        .faq-item {
          background: white;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          margin-bottom: 16px;
          cursor: pointer;
          transition: all 0.3s ease;
          overflow: hidden;
        }

        .faq-item:hover {
          border-color: #0a2458;
          box-shadow: 0 5px 15px rgba(10, 36, 88, 0.1);
        }

        .faq-item.active {
          border-color: #0a2458;
        }

        .faq-question {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px;
        }

        .faq-question h3 {
          font-size: 1.125rem;
          color: #0a2458;
          font-weight: 600;
          margin: 0;
          flex: 1;
        }

        .faq-toggle {
          font-size: 24px;
          color: #0a2458;
          transition: transform 0.3s ease;
        }

        .faq-item.active .faq-toggle {
          transform: rotate(45deg);
        }

        .faq-answer {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease;
          padding: 0 20px;
        }

        .faq-item.active .faq-answer {
          padding: 0 20px 20px;
        }

        .faq-answer p {
          color: #0a2458;
          line-height: 1.6;
          margin: 0;
        }

        /* CTA Section */
        .cta-section {
          background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
          padding: 100px 0;
          color: white;
          position: relative;
          overflow: hidden;
        }

        .cta-section::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background:
            radial-gradient(
              circle at 25% 25%,
              rgba(255, 215, 0, 0.1) 2px,
              transparent 2px
            ),
            radial-gradient(
              circle at 75% 75%,
              rgba(255, 255, 255, 0.05) 2px,
              transparent 2px
            );
          background-size: 40px 40px;
        }

        .cta-title {
          font-size: clamp(2rem, 4vw, 2.75rem);
          color: white;
          font-weight: 700;
          margin-bottom: 1rem;
          position: relative;
          z-index: 1;
        }

        .cta-subtitle {
          font-size: 1.25rem;
          color: rgba(255, 255, 255, 0.9);
          max-width: 700px;
          margin: 0 auto 50px;
          line-height: 1.6;
          position: relative;
          z-index: 1;
        }

        .cta-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border-radius: 20px;
          padding: 30px;
          height: 100%;
          position: relative;
          z-index: 1;
          transition: transform 0.3s ease;
          display: flex;
          flex-direction: column;
        }

        .cta-card:hover {
          transform: translateY(-10px);
        }

        .cta-icon {
          font-size: 48px;
          margin-bottom: 20px;
        }

        .cta-card-title {
          font-size: 1.5rem;
          color: #0a2458;
          font-weight: 600;
          margin-bottom: 1rem;
        }

        .cta-card-description {
          color: #0a2458;
          margin-bottom: 1rem;
          line-height: 1.5;
        }

        .cta-card-list {
          padding-left: 20px;
          margin-bottom: 2rem;
          flex: 1;
        }

        .cta-card-list li {
          color: #0a2458;
          margin-bottom: 0.5rem;
          line-height: 1.4;
        }

        .cta-card-button {
          background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
          color: white;
          border: none;
          padding: 15px 25px;
          border-radius: 12px;
          font-weight: 600;
          width: 100%;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .cta-card-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(10, 36, 88, 0.3);
        }

        .contact-info {
          position: relative;
          z-index: 1;
        }

        .contact-item {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .contact-icon {
          font-size: 24px;
        }

        .contact-label {
          font-size: 0.875rem;
          color: rgba(255, 255, 255, 0.8);
        }

        .contact-value {
          font-size: 1.125rem;
          font-weight: 600;
          color: white;
        }

        .contact-value.highlight {
          color: #ffd700;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .hero-section {
            padding: 60px 0;
            min-height: auto;
          }

          .section-title {
            font-size: 2rem;
          }

          .section-subtitle {
            font-size: 1rem;
          }

          .problem-section,
          .solution-section,
          .services-section,
          .process-section,
          .case-study-section,
          .technologies-section,
          .comparison-section,
          .faq-section,
          .cta-section {
            padding: 60px 0;
          }

          .process-step {
            padding: 25px 20px 25px 25px;
          }

          .step-number {
            width: 40px;
            height: 40px;
            font-size: 18px;
          }

          .step-title {
            font-size: 1.25rem;
          }

          .comparison-table {
            overflow-x: auto;
          }

          .comparison-table table {
            min-width: 600px;
          }

          .faq-question h3 {
            font-size: 1rem;
          }

          .cta-title {
            font-size: 2rem;
          }

          .cta-subtitle {
            font-size: 1.125rem;
          }
        }

        @media (max-width: 480px) {
          .section-title {
            font-size: 1.75rem;
          }

          .process-step {
            padding: 20px 15px 20px 20px;
          }

          .step-content {
            margin-left: 15px;
          }

          .faq-question {
            padding: 15px;
          }

          .faq-answer {
            padding: 0 15px;
          }

          .faq-item.active .faq-answer {
            padding: 0 15px 15px;
          }
        }

        /* Animation Classes */
        .min-vh-90 {
          min-height: 90vh;
        }
      `}</style>
    </div>
  );
}
